import React from "react";

const CookiePolicy = () => {
  return (
    <div className="bg-black w-full min-h-[calc(100vh-120px)] py-12">
      <div className="text-gray-400 font-secondary px-8 max-w-[900px] mx-auto md:px-6 sm:px-4 text-left">
        <h1 className="font-primary text-[2.8rem] text-center mb-10 text-white font-bold md:text-[2.2rem] sm:text-[1.8rem] uppercase">
          FOZZIL COOKIE POLICY
        </h1>

        <section className="mb-10">
          <p className="text-[1.1rem] leading-[1.7] text-gray-500 mb-8 text-center sm:text-[1rem]">
            Last Updated: 26th March, 2026
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-6 sm:text-[1rem]">
            This Cookie Policy outlines how FOZZIL uses cookies and similar
            technologies across our web-based services, including{" "}
            <span className="underline">https://fozzil.in</span> and related
            domains. For details on how we collect and process your personal
            information, please refer to our Privacy Policy.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            What Are Cookies?
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            Cookies are small text files that may be stored on your device when you
            access a website or web-based application. They allow websites to
            recognize your device, remember preferences, and enhance the
            performance, functionality, and security of services.
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            We may also use technologies similar to cookies, such as local storage,
            to help us operate and improve our digital platforms.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Why Does FOZZIL Use Cookies?
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            FOZZIL only uses strictly necessary cookies that are essential for the
            operation, security, and basic functionality of our services. We do not
            use cookies for advertising, marketing, or user tracking beyond what is
            required to secure and deliver core functionality.
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            These cookies help us:
          </p>
          <ul className="list-disc pl-8 mt-2 mb-6 text-gray-400">
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">Ensure account and session security</li>
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">Enable secure login and user authentication</li>
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">Maintain essential service functionality</li>
          </ul>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            Since these cookies are required for our systems to work properly, they
            cannot be disabled through standard cookie controls.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            List of Cookies Used
          </h2>
          <div className="overflow-x-auto mb-8 border border-gray-800 rounded-lg">
            <table className="min-w-full text-left">
              <thead className="bg-[#111] text-gray-200">
                <tr>
                  <th className="py-4 px-6 border-b border-gray-800">Source</th>
                  <th className="py-4 px-6 border-b border-gray-800">Name</th>
                  <th className="py-4 px-6 border-b border-gray-800">Purpose</th>
                  <th className="py-4 px-6 border-b border-gray-800">Duration</th>
                  <th className="py-4 px-6 border-b border-gray-800">Domain</th>
                </tr>
              </thead>
              <tbody className="text-gray-400">
                <tr className="border-b border-gray-800/50">
                  <td className="py-4 px-6">FOZZIL</td>
                  <td className="py-4 px-6 font-mono text-sm">csrf</td>
                  <td className="py-4 px-6">Security</td>
                  <td className="py-4 px-6">30 mins</td>
                  <td className="py-4 px-6">All</td>
                </tr>
                <tr className="border-b border-gray-800/50">
                  <td className="py-4 px-6">FOZZIL</td>
                  <td className="py-4 px-6 font-mono text-sm">sso</td>
                  <td className="py-4 px-6">Login</td>
                  <td className="py-4 px-6">4 weeks</td>
                  <td className="py-4 px-6">All</td>
                </tr>
                <tr>
                  <td className="py-4 px-6">FOZZIL</td>
                  <td className="py-4 px-6 font-mono text-sm">referrer</td>
                  <td className="py-4 px-6">Service Functionality</td>
                  <td className="py-4 px-6">30 days</td>
                  <td className="py-4 px-6">taels.fozzil.in</td>
                </tr>
                <tr className="border-t border-gray-800/50">
                  <td className="py-4 px-6">FOZZIL</td>
                  <td className="py-4 px-6 font-mono text-sm">fozzil_cookie_consent</td>
                  <td className="py-4 px-6">Cookie Preferences</td>
                  <td className="py-4 px-6">Persistent</td>
                  <td className="py-4 px-6">All</td>
                </tr>
                <tr className="border-t border-gray-800/50">
                  <td className="py-4 px-6">Supabase (Auth Provider)</td>
                  <td className="py-4 px-6 font-mono text-sm">sb-*-auth-token</td>
                  <td className="py-4 px-6">Authentication Session</td>
                  <td className="py-4 px-6">Session / 4 weeks</td>
                  <td className="py-4 px-6">All</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-[1rem] italic text-gray-500 mb-8">
            Note: FOZZIL may update this list periodically to reflect changes in
            cookie usage as part of service improvements.
          </p>
        </section>

        <section className="mb-10 text-center border-t border-gray-800 pt-10">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white md:text-[1.5rem] sm:text-[1.3rem]">
            Contact Us
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            For questions or concerns regarding our use of cookies, please contact:
            <br />
            <span className="text-white font-bold">FOZZIL LEGAL</span><br />
            Chennai- 603203 Tamil Nadu, India<br />
            <a href="mailto:legal@fozzil.in" className="text-blue-400 hover:underline">legal@fozzil.in</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicy;
